import PropTypes from 'prop-types';
import { compose, getContext, withHandlers } from 'recompose';
import { uniqueId } from 'lodash/fp';

const withNotificationCallback = compose(
  getContext({
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
    }).isRequired,
  }),
  withHandlers({
    removeNotification: ({ notifications }) => notifications.remove,
    transmitNotification: ({ notifications }) => (config = {}) => {
      const id = config.id || uniqueId('NOTIFICATION_AUTOGEN_');

      notifications.add(id, {
        confirmText: config.confirmText,
        message: config.message,
        onClose: config.onClose,
        onConfirm: config.onConfirm,
        type: config.type,
      });

      if (!config.persist) {
        // make sure the notification has rendered on screen before starting the timer
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            notifications.remove(id);
          }, 5000);
        });
      }
    },
  }),
);

export default withNotificationCallback;
